<template>
	<el-dialog title="读卡点详细信息" v-model="dialogVisible" width="30%" :before-close="handleClose">
		<el-form>
			<!-- <el-form-item label="所属学校:" prop="rfid" label-width="100px">
              <el-input  v-model="form.schoolName"  autocomplete="off"></el-input>
        </el-form-item> -->
			<el-form-item label="所属学校" prop="schoolName" label-width="100px">
				<el-select v-model="form.schoolName" filterable placeholder="请选择学校" @change="schoolClick">
					<el-option :label="item.name" :value="item.id" v-for="item in schoolList"
						:key="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="名称:" prop="rfid" label-width="100px">
				<el-input v-model="form.name" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="类型:" prop="rfid" label-width="100px">
				<el-select v-model="form.region" filterable placeholder="活动区域">
					<!-- <el-option label="区域一" value="shanghai"></el-option> -->
					<el-option :label="item.name" :value="item.value" v-for="item in formSourcesList"
						:key="item.name"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="读卡器:" prop="rfid" label-width="100px">
				<!-- <el-input  v-model="form.card"  autocomplete="off"></el-input>
              <el-input  v-model="form.card1"  autocomplete="off"></el-input> -->
				<el-select v-model="form.card" filterable placeholder="">
					<el-option :label="item.name" :value="item.id" v-for="item in cardData" :key="item.id"></el-option>
				</el-select>
				<el-select v-model="form.card1" filterable placeholder="" v-if="form.region == '1'">
					<el-option :label="item.name" :value="item.id" v-for="item in cardData" :key="item.id"></el-option>
				</el-select>
			</el-form-item>
			<!-- <el-form-item   label="控制门禁:" prop="rfid" label-width="100px">
                    <el-radio-group v-model="form.checked">
                        <el-radio label="是" ></el-radio>
                        <el-radio label="否" ></el-radio>
                    </el-radio-group>
        </el-form-item> -->
			<div class="buttom-box">
				<el-button type="primary" @click="AddClick()">提交</el-button>
				<el-button @click="handleClose">返回</el-button>
			</div>
		</el-form>

	</el-dialog>
</template>
<script>
	import {
		readerCardPointbaseInfoe,
		CardAddValue,
		addReader
	} from '@/assets/api/schoollog'
	// import { ElMessage } from 'element-plus'
	import {schoolList} from '@/assets/api/renyuan'
	export default {
		components: {},
		props: ['xinxiObj'],
		data() {

			return {
				dialogVisible: true,
				title: '',
				form: {
					schoolName: '',
					name: '',
					type: '',
					card: '',
					card1: '',
					checked: '',
					region: ''
				},
				cardid: "",
				schoolList: [],
				cardData: [],
				formSourcesList: [{
						value: '0',
						name: '单卡'
					},
					{
						value: '1',
						name: '双卡'
					},
					{
						value: '2',
						name: 'D模式'
					},
					{
						value: '3',
						name: '13.56M模式'
					},
					{
						value: '4',
						name: '校车模式'
					},
					{
						value: '5',
						name: '人脸机-进'
					},
					{
						value: '6',
						name: '人脸机-出'
					}
				]

			}

		},
		created() {
			this.schoolPost()
			this.detailCard()
			this.CardValue()
		},
		mounted() {

		},
		methods: {
			handleClose() {
				this.$emit('backDkaqiClick')
			},
			AddClick() {
				let params = {}
				if (this.form.region == '1') {
					params = {
						readerOneId: this.form.card,
						readerTwoId: this.form.card1,
						readerPointId: this.xinxiObj.readPointId,
						type: this.form.region
					}
				} else {
					params = {
						readerOneId: this.form.card,
						readerPointId: this.xinxiObj.readPointId,
						type: this.form.region
					}
				}
				addReader(params).then((res) => {
					this.handleClose()
				}).catch((err) => {
					console.log(err);
				})
			},
			schoolPost(schooName) {
				let params = JSON.parse(localStorage.getItem('user')).id;
				schoolList(params).then((res) => {
					// console.log(res,'学校列表');
					this.schoolList = res.data.data;
				}).catch((err) => {
					console.log(err);
				})
			},
			//详细数据
			detailCard() {
				const params = {
					id: this.xinxiObj.readPointId
				}
				readerCardPointbaseInfoe(params).then((res) => {
					console.log(res, '成功');
					this.form.name = res.data.data.name
					this.form.schoolName = res.data.data.schoolName
					this.form.checked = res.data.data.checked == 1 ? '是' : '否'
				}).catch((err) => {
					console.log(err, '失败');
				})
			},

			//读卡器id数据
			CardValue() {
				const params = {
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				CardAddValue(params).then((res) => {
					// console.log(res,1);
					this.cardData = res.data.data
				}).catch((err) => {
					console.log(err, 2);

				})
			}
			// deviceClick(){
			//     console.log(this.Deviceidobj,'11111111111111');
			//     // const params = {
			//         //     rfid:this.form.rfid,
			//         //     studentId:this.Deviceidobj.studentId
			//         // }
			//     studentRfidAdd(this.form.rfid,this.Deviceidobj.studentId).then((res)=> {
			//             console.log(res,'成功');
			//             this.handleClose()
			//     }).catch((err) => {
			//         console.log(err,'失败');
			//     })
			//   }

		}
	}
</script>
<style scoped lang="scss">
	:deep() {
		.el-input--small .el-input__wrapper {
			height: 35px;
			line-height: 35px;
			text-align: center;
			width: 280px;
		}

		.el-input__inner {
			// width: 10px !important;
		}

		.buttom-box {
			// text-align: center;
			margin-left: 180px;

		}

		.el-form-item--small {
			width: 70% !important;
		}
	}
</style>